import { render, staticRenderFns } from "./shipUnload.vue?vue&type=template&id=64259353&scoped=true&"
import script from "./shipUnload.vue?vue&type=script&lang=js&"
export * from "./shipUnload.vue?vue&type=script&lang=js&"
import style0 from "./shipUnload.vue?vue&type=style&index=0&id=64259353&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64259353",
  null
  
)

export default component.exports